import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 确认 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("停用")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_9 = { style: {"display":"flex","justify-content":"flex-end"} }

import stubs from '@/init';
import { computed, reactive } from 'vue';
import { ElMessage } from 'element-plus';
import SubsidiaryController from './controller/Subsidiary.Controller';
import { SubsidiaryVO, SubsidiaryStatusEnum } from './vo';
import SimpleSelect from '@/components/common/high/SimpleSelect.vue';
import { param } from 'jquery';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const controller: SubsidiaryController =
  stubs.injector.get(SubsidiaryController);
const state = reactive({
  editSubsidiary: {} as SubsidiaryVO,
  data: [] as Array<SubsidiaryVO>,
  dialogFormVisible: false,
  editMode: false,
  form: {
    regionId: '',
    page: 1,
    size: 10,
  },
  total: 0,
});

const obtainPocket = (pocketName: string) =>
  stubs.pockets.obtainPocket(pocketName);

const city = computed(() =>
  obtainPocket('city').filter(
    (it) => it.extra.provinceKey === state.editSubsidiary.province
  )
);

const ruleForm = {
  regionId: [{ required: true, message: '请选择区域', trigger: 'blur' }],
  name: [{ required: true, message: '请填写分公司名称', trigger: 'blur' }],
  province: [
    { required: true, message: '请选择省/市', trigger: 'blur' },
    {
      required: 'true',
      trigger: 'change',
      validator: (rule: any, value: any, callback: any) => {
        if (value && state.editSubsidiary.city) {
          callback();
          return;
        }
        callback(new Error('请选择省/市'));
      },
    },
  ],
};

const search = async (page?: number) => {
  if (page) {
    state.form.page = page;
  }
  const res = await controller.search(state.form);
  state.data = res.result;
  state.total = res.totalElements || 0;
};

const addOrEdit = (Subsidiary = {} as SubsidiaryVO) => {
  state.editMode = Subsidiary?.id?.length > 0;
  state.editSubsidiary = { ...Subsidiary };
  state.dialogFormVisible = true;
};

const confirm = async (Subsidiary: SubsidiaryVO) => {
  await controller.upset(Subsidiary);
  ElMessage.success('创建/修改成功!');
  state.dialogFormVisible = false;
  search();
};

const enableOrDisableSubsidiary = async (
  Subsidiary: SubsidiaryVO,
  status: Boolean
) => {
  Subsidiary.disabled = status;
  var param = { ...Subsidiary };
  param.disabled = status;
  await controller.update(param);
  ElMessage.success('操作成功!');
  search();
};

search();

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_mas_form_main = _resolveComponent("mas-form-main")!
  const _component_wapper = _resolveComponent("wapper")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_simple_table_column = _resolveComponent("simple-table-column")!
  const _component_simple_confirm_button = _resolveComponent("simple-confirm-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_wapper, null, {
      default: _withCtx(() => [
        _createVNode(_component_mas_form_main, {
          inline: true,
          form: _unref(state).form,
          defaultFormFooterButton: ['confirm'],
          defaultFormFooterConfirmText: "搜索",
          "label-width": "120px",
          onConfim: _cache[1] || (_cache[1] = ($event: any) => (search(1)))
        }, {
          content: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "大区" }, {
              default: _withCtx(() => [
                _createVNode(SimpleSelect, {
                  style: {"width":"240px"},
                  options: _ctx.pocket('region'),
                  clearable: "",
                  filterable: "",
                  modelValue: _unref(state).form.regionId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).form.regionId) = $event))
                }, null, 8, ["options", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["form"])
      ]),
      _: 1
    }),
    _createVNode(_component_wapper, null, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (addOrEdit()))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_dialog, {
              modelValue: _unref(state).dialogFormVisible,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(state).dialogFormVisible) = $event)),
              title: _unref(state).editMode ? '编辑' : '新增',
              width: "600"
            }, {
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_button, {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(state).dialogFormVisible = false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ((_ctx.$refs.masForm as any).confirm()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ])
              ]),
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_component_mas_form_main, {
                  ref: "masForm",
                  form: _unref(state).editSubsidiary,
                  defaultFormFooterButton: [],
                  ruleForm: ruleForm,
                  "label-width": "120px",
                  key: _unref(state).dialogFormVisible,
                  onConfim: confirm
                }, {
                  content: _withCtx((slotProps) => [
                    _createVNode(_component_el_form_item, {
                      label: "大区",
                      prop: "regionId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(SimpleSelect, {
                          options: _ctx.pocket('region'),
                          filterable: "",
                          modelValue: slotProps.content.regionId,
                          "onUpdate:modelValue": ($event: any) => ((slotProps.content.regionId) = $event)
                        }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, {
                      label: "名称",
                      prop: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: slotProps.content.name,
                          "onUpdate:modelValue": ($event: any) => ((slotProps.content.name) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, {
                      label: "省/市",
                      prop: "province"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(SimpleSelect, {
                          filterable: "",
                          modelValue: slotProps.content.province,
                          "onUpdate:modelValue": ($event: any) => ((slotProps.content.province) = $event),
                          options: _ctx.pocket('province')
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]),
                        _createVNode(SimpleSelect, {
                          modelValue: slotProps.content.city,
                          "onUpdate:modelValue": ($event: any) => ((slotProps.content.city) = $event),
                          options: _unref(city)
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }, 8, ["form"]))
              ]),
              _: 1
            }, 8, ["modelValue", "title"])
          ]),
          _createVNode(_component_el_table, {
            class: "common-table",
            data: _unref(state).data,
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_simple_table_column, {
                label: "大区名称",
                prop: "regionId",
                pocketName: "region"
              }),
              _createVNode(_component_simple_table_column, {
                label: "分公司名称",
                prop: "name"
              }),
              _createVNode(_component_simple_table_column, {
                label: "省/市",
                "min-width": "120px"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_ctx.pocketLabel('province', row.province)) + "/" + _toDisplayString(_ctx.pocketLabel('city', row.city)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_simple_table_column, {
                label: "创建时间",
                prop: "createTime"
              }),
              _createVNode(_component_simple_table_column, {
                label: "修改时间",
                prop: "updateTime"
              }),
              _createVNode(_component_simple_table_column, { label: "状态" }, {
                default: _withCtx(({ row }: { row: SubsidiaryVO }) => [
                  _createTextVNode(_toDisplayString(row.disabled ? '停用' : '启用'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_simple_table_column, { label: "操作" }, {
                default: _withCtx(({ row }: { row: SubsidiaryVO }) => [
                  (row.disabled)
                    ? (_openBlock(), _createBlock(_component_simple_confirm_button, {
                        key: 0,
                        title: "确认要启用该分公司吗？",
                        onClick: ($event: any) => (enableOrDisableSubsidiary(row, false))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (!row.disabled)
                    ? (_openBlock(), _createBlock(_component_simple_confirm_button, {
                        key: 1,
                        title: "确认要停用该分公司吗？",
                        onClick: ($event: any) => (enableOrDisableSubsidiary(row, true))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (!row.disabled)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 2,
                        type: "text",
                        onClick: ($event: any) => (addOrEdit(row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_pagination, {
              total: _unref(state).total,
              "current-page": _unref(state).form.page,
              "page-size": _unref(state).form.size,
              onCurrentChange: search,
              layout: "total, prev, pager, next, jumper"
            }, null, 8, ["total", "current-page", "page-size"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})